<template>
    <v-card>
        <v-layout>
            <v-flex xs12>
                <v-layout>
                    <v-flex xs12>
                        <h1 class="text-xs-center">Audit Logs</h1>
                    </v-flex>
                </v-layout>                
                <v-form v-model="searchFormValid">
                    <v-layout wrap>
                        <v-flex xs12 sm2 offset-sm1>
                            <v-text-field
                                v-model="search.modifiedByEmail"
                                append-icon="search"
                                label="Filter Modified By"
                                single-line
                                hide-details
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm2 offset-sm1>
                            <v-text-field
                                v-model="search.occurredAt"
                                append-icon="search"
                                label="Filter Occurred At"
                                single-line
                                hide-details
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm2 offset-sm1>
                            <v-text-field
                                v-model="search.context"
                                append-icon="search"
                                label="Filter Context"
                                single-line
                                hide-details
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm2 offset-sm1>
                            <v-btn block color="success" :disabled="!searchFormValid" :loading="loading" @click="loadAuditLogs">Search</v-btn>
                        </v-flex>
                    </v-layout>
                </v-form>
                <v-layout>
                    <v-flex xs12>
                        <v-data-table
                            :headers="headers"
                            :items="auditLogs"
                            :loading="loading"
                            must-sort
                            :rows-per-page-items="rowsPerPage"
                            :pagination.sync="pagination"
                            :total-items="totalAuditLogs"
                        >
                            <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                            <template slot="items" slot-scope="props">
                                <tr :data-id="props.item.ID">
                                    <td>{{props.item.ID}}</td>
                                    <td>{{props.item.ModifiedByEmail}}</td>
                                    <td>{{props.item.OccurredAt}}</td>
                                    <td>{{props.item.Context}}</td>
                                    <td>
                                        <v-btn
                                            color="warning"
                                            block
                                            @click="viewDetailsAuditLog(props.item)"
                                        >
                                            View Details
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                            <template v-if="!loading" slot="no-data">
                                <v-alert v-if="loadError" outline :value="true" color="error" icon="error">
                                    {{loadError}}
                                </v-alert>
                                <v-alert v-if="!loadError" outline :value="true" type="info">
                                    No results found
                                </v-alert>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-dialog v-model="showViewDetailsDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="cancelViewDetailsAuditLog">
                            <v-icon large>close</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-toolbar-title>Audit Log Details</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            
                        </v-toolbar-items>
                    </v-toolbar>
                        <v-layout class="dialog-content">
                            <v-flex xs12 md6 offset-md3>
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="selectedAuditLog.ID"
                                            :readonly="true"
                                            label="Identifier">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-text-field
                                            v-model="selectedAuditLog.ModifiedByEmail"
                                            :readonly="true"
                                            label="Modified By Email">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-text-field
                                            v-model="selectedAuditLog.ModifiedByADObjectID"
                                            :readonly="true"
                                            label="Modified By Active Directory">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="selectedAuditLog.OccurredAt"
                                            :readonly="true"
                                            label="Occurred At">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="selectedAuditLog.Context"
                                            :readonly="true"
                                            label="Context">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="selectedAuditLog.AuditType"
                                            :readonly="true"
                                            label="Database Action Type">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-data-table
                                            :headers="auditLogValuesHeaders"
                                            :items="auditLogValues"
                                            :loading="loading"
                                            :search="auditLogValuesSearch"
                                            hide-actions
                                            must-sort
                                        >
                                            <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                                            <template slot="items" slot-scope="props">
                                                <tr :data-id="props.item.ID">
                                                    <td>{{props.item.AffectedTable}}</td>
                                                    <td>{{props.item.AffectedColumn}}</td>
                                                    <td>{{props.item.OldValue}}</td>
                                                    <td>{{props.item.NewValue}}</td>
                                                </tr>
                                            </template>
                                            <template v-if="!loading" slot="no-data">
                                                <v-alert v-if="loadError" outline :value="true" color="error" icon="error">
                                                    {{loadError}}
                                                </v-alert>
                                                <v-alert v-if="!loadError" outline :value="true" type="info">
                                                    No results found
                                                </v-alert>
                                            </template>
                                        </v-data-table>
                                    </v-flex>
                                </v-layout>   
                                <v-layout wrap class="dialog-action-buttons">
                                    <v-flex xs12>
                                        <v-btn block color="info" @click="cancelViewDetailsAuditLog">Back</v-btn>
                                    </v-flex>
                                </v-layout>                          
                            </v-flex>
                        </v-layout>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-card>
</template>

<script>
export default {
    components: {
    },
    props: [
        
    ],
    data() {
        return {
            infoVisible: false,
            selectedAuditLog: {},
            showViewDetailsDialog: false,
            searchFormValid: false,
            search: {
                modifiedByEmail: "",
                occurredAt: "",
                context: ""
            },
            rowsPerPage: [20, 50, 100],
            pagination: {
                rowsPerPage: 20, // default
                sortBy: "OccurredAt",
                descending: true
            },
            headers: [
                {
                    text: "Identifier",
                    value: "ID"
                },
                {
                    text: "Modified By",
                    value: "ModifiedByEmail"
                },
                {
                    text: "Occurred At",
                    value: "OccurredAt"
                },
                {
                    text: "Context",
                    value: "Context"
                },
                {
                    text: "", // view button
                    sortable: false
                }
            ],
            auditLogValuesSearch: "",
            auditLogValuesHeaders: [
                {
                    text: "Table",
                    value: "AffectedTable"
                },
                {
                    text: "Column",
                    value: "AffectedColumn"
                },
                {
                    text: "Old Value",
                    value: "OldValue"
                },
                {
                    text: "New Value",
                    value: "NewValue"
                }
            ]
        };
    },
    watch: {
        pagination: {
            handler(){
                this.loadAuditLogs();
            },
            deep: true
        }
    },
    computed: {
        loading() {
            return this.$store.state.auditLogStore.loading
            || this.$store.state.auditLogStore.values.loading;
        },
        loadError() {
            return this.$store.state.auditLogStore.loadError
            || this.$store.state.auditLogStore.values.loadError;
        },
        auditLogs() {
            return this.$store.state.auditLogStore.auditLogs.map(aL => {
                aL.OccurredAt = this.formatDate(aL.OccurredAt);

                return aL;
            });
        },
        totalAuditLogs(){
            return this.$store.state.auditLogStore.totalAuditLogs;
        },
        auditLogValues() {
            return this.$store.state.auditLogStore.values.auditLogValues.filter(aLV => this.selectedAuditLog && aLV.AuditID === this.selectedAuditLog.ID);
        }
    },
    methods: {
        loadAuditLogs() {
            let that = this;

            this.$store.dispatch("auditLogStore/loadAuditLogs", {
                PaginationPage: this.pagination.page,
                PaginationPageSize: this.pagination.rowsPerPage,
                SortBy: this.pagination.sortBy,
                SortDirection: this.pagination.descending ? "DESC" : "ASC",
                SearchModifiedByEmail: this.search.modifiedByEmail,
                SearchOccurredAt: this.search.occurredAt,
                SearchContext: this.search.context
            });
        },
        viewDetailsAuditLog(item) {
            this.selectedAuditLog = Object.assign({}, item);
            this.$store.dispatch("auditLogStore/loadAuditLogValues", { 
                AuditLog: this.selectedAuditLog
            });
            this.auditLogValuesSearch = "";
            this.showViewDetailsDialog = true;
        },
        cancelViewDetailsAuditLog() {
            this.showViewDetailsDialog = false;
            this.selectedAuditLog = {};
        },
        formatDate(dateString){
            let date = new Date(dateString);

            let day = date.getDate();
            let month = date.getMonth() + 1;
            let year = date.getFullYear();
            let hour = date.getHours() + "";
            if(hour.length == 1){
                hour = "0" + hour;
            }

            let minute = date.getMinutes() + "";
            if(minute.length == 1){
                minute = "0" + minute;
            }

            let second = date.getSeconds() + "";
            if(second.length == 1){
                second = "0" + second;
            }

            return day + "/" + month + "/" + year + " " + hour + ":" + minute + ":" + second;
        }
    }
};
</script>

<style>
    
</style>